module.exports = "<div>\n    <div class=\"alert alert-danger\" role=\"alert\" *ngIf=\"errors.count() && control.dirty\">\n        <p *ngFor=\"let error of errors.all()\">\n            {{ error.message | translate:error.parameters }}\n        </p>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/forms/form/components/messages/messages.component.html
// module id = ./libs/chassis-core/src/app/forms/form/components/messages/messages.component.html
// module chunks = main